import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button, Select } from '@/ui';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledActionsWrap = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const StyledClearButton = styled(Button)`
  &&& {
    height: 2.5rem;

    svg {
      width: 0.65rem;
    }
  }
`;

export const StyledSelect = styled(Select)`
  &&& {
    height: 2.5rem !important;

    .ant-select-selection-placeholder {
      color: ${COLORS.BLACK};
    }
  }
`;

export const StyledCreateButton = styled(Button)`
  &&& {
    max-width: 13rem;
    height: 2.125rem;

    svg {
      fill: ${COLORS.BLACK};
    }
  }
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('24', '30', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
`;

export const StyledTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: flex-start;
`;

export const StyledZeroPriceFilter = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledHeaderBlock = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  padding: 2rem;
  min-height: 6.75rem;
  background: ${COLORS.GRAY_LIGHT};
  border-bottom: 1px solid ${COLORS.GREY};
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const StyledButton = styled(Button)`
  svg {
    margin-right: 0.5rem;
  }
`;

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('20', '24', 'SEMI_BOLD')};
  margin-bottom: 2rem;
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  &&& {
    button {
      ${pickThemeFontStyles('14', '22', 'BOLD')};
      width: 100%;
      color: ${COLORS.WHITE};
    }
  }
`;
